export function parsePastedInteger(text: string): number | null {
  const digits = text.replace(/\D/g, '');
  if (!digits) {
    return null;
  }

  return parseInt(digits, 10);
}
